import React, { useEffect, useState } from "react";

const StatoCivileSelect = (props) => {
  const dizionarioStatoCivile = {
    0: "Non definito",
    1: "Celibe/Nubile",
    2: "Coniugato/a",
    3: "Vedovo/a",
    9: "Divorziato/a",
    4: "Non classificabile/ignoto/n.c",
    6: "Unito civilmente",
    7: "Stato libero a seguito di decesso della parte unita civilmente",
    8: "Stato libero a seguito di scioglimento dell'unione",
  };

  const [selected, setSelected] = useState(props.selectedValue);

  const handleChange = (event) => {
    setSelected(event.target.value);
  };

  return (
    <div>
      <select
        onChange={(e) => {
          handleChange(e);
          props.onChangeSelect(e);
        }}
      >
        <option hidden>{dizionarioStatoCivile[props.selectedValue]}</option>
        {Object.entries(dizionarioStatoCivile).map(([key, value]) => (
          <option key={key} value={key}>
            {value}
          </option>
        ))}
      </select>
    </div>
  );
};

export default StatoCivileSelect;
